import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import VideoGrid from './components/VideoGrid';
import { hotVideos, newVideos, videos } from '@/mocks/videos';

// Homepage JSON-LD
const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '蓝莓视频',
  url: 'https://www.blueberryvideo.com',
  description: '蓝莓视频是91视频、97视频等数字视频平台的优质替代，提供高清免费在线观看，电视剧全集电影大全，不缓冲流畅体验。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.blueberryvideo.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '蓝莓视频',
  url: 'https://www.blueberryvideo.com',
  description: '蓝莓视频 - 数字视频平台，提供高清免费在线视频观看服务',
  sameAs: [
    'https://weibo.com/blueberryvideo',
    'https://www.blueberryvideo.com',
  ],
};

const webPageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '蓝莓视频 - 91视频97视频91视频网站同类数字视频平台',
  description: '蓝莓视频是91视频97视频等数字视频平台的优质替代，提供高清免费在线观看，电视剧全集电影大全，不缓冲流畅体验。',
  url: 'https://www.blueberryvideo.com',
  isPartOf: {
    '@type': 'WebSite',
    name: '蓝莓视频',
    url: 'https://www.blueberryvideo.com',
  },
};

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background-50">
      {/* Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageJsonLd) }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <VideoGrid
          title="热门推荐"
          subtitle="全网最受欢迎的精彩内容"
          videos={hotVideos}
          columns={4}
        />
        <VideoGrid
          title="最新上线"
          subtitle="刚刚更新的新鲜内容"
          videos={newVideos}
          columns={4}
        />
        <VideoGrid
          title="猜你喜欢"
          subtitle="根据您的喜好精心挑选"
          videos={videos.filter((_, i) => i % 2 === 0).slice(0, 8)}
          columns={4}
        />
      </main>
      <Footer />
    </div>
  );
}